module.exports = __webpack_public_path__ + "media/logos/bloomberg-logo-white-cdf42293.png";